<script lang="ts" setup>
import { AppCard, AppTypography } from '#core/components/';
import { computed, ref } from 'vue';
import EmailForm from './EmailForm.vue';
import ResetPasswordForm from './ResetPasswordForm.vue';
import VerifyForm from './VerifyForm.vue';

const formType = ref<'email' | 'otp' | 'password'>('email');

const username = ref();
const token = ref();

const subtitle = computed(() => {
  const subtitles: Partial<Record<'email' | 'otp' | 'password', string>> = {
    email: "Enter your email and we'll send you a password reset link",
  };
  return subtitles[formType.value] ?? '';
});

const title = computed(() => {
  const titles = {
    email: 'Forgot Password',
    otp: 'Verification Code',
    password: 'New Password',
  };
  return titles[formType.value];
});
</script>

<template>
  <AppCard :title="title" :subtitle="subtitle" class="d-flex flex-column gap-3xl">
    <template v-if="formType === 'otp'" #subtitle>
      <AppTypography>
        Enter the code sent to <span class="font-body-semibold">{{ username }}</span>
      </AppTypography>
    </template>
    <template v-if="formType === 'password'" #subtitle>
      <AppTypography>
        Enter your new password to log into <span class="font-body-semibold">{{ username }}</span>
      </AppTypography>
    </template>

    <EmailForm
      v-if="formType === 'email'"
      data-testid="email-form"
      @next="
        formType = 'otp';
        username = $event;
      "
    />

    <VerifyForm
      v-if="formType === 'otp'"
      :username="username"
      data-testid="verify-form"
      @next="
        formType = 'password';
        token = $event;
      "
    />

    <ResetPasswordForm
      v-if="formType === 'password'"
      data-testid="reset-password-form"
      :username="username"
      :token="token"
    />
  </AppCard>
</template>

<style lang="scss" scoped>
.v-card {
  margin-top: 64px;
}
</style>
